const topics = [
  { name: '热血战斗', count: '3,826', hot: true },
  { name: '恋爱日常', count: '2,951', hot: true },
  { name: '奇幻冒险', count: '3,402', hot: true },
  { name: '悬疑推理', count: '1,876', hot: false },
  { name: '科幻未来', count: '1,543', hot: false },
  { name: '治愈系', count: '2,108', hot: true },
  { name: '校园青春', count: '2,674', hot: false },
  { name: '异世界', count: '4,215', hot: true },
  { name: '搞笑喜剧', count: '1,932', hot: false },
  { name: '运动竞技', count: '1,267', hot: false },
  { name: '美食番', count: '856', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">热门话题标签</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            按话题热度发现最受读者欢迎的动漫类型，点击探索更多
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((topic) => (
            <a
              key={topic.name}
              href="#topics"
              className="group flex items-center gap-2 px-4 py-2.5 bg-background-50 border border-background-200/60 hover:border-primary-200 rounded-full transition-colors cursor-pointer"
            >
              {topic.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
              )}
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-500 transition-colors whitespace-nowrap">{topic.name}</span>
              <span className="text-xs text-foreground-400">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}